import React from 'react';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit,}) => {
    const rows = [
        { label: 'Address', value: data.address, fullWidth: true },
        { label: 'Payment Terms', value: data.paymentTerms, fullWidth: true },
        { label: 'Terms and Conditions', value: data.termsAndConditions, fullWidth: true },
        { label: 'GST Number', value: data.gstNumber },
        { label: 'Bank Name', value: data.bankName },
        { label: 'Account Number', value: data.accountNumber },
        { label: 'IFSC Code', value: data.ifscCode },
        { label: 'Branch Name', value: data.branchName },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.companyName}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
